export const API_URL = process.env.REACT_APP_API_URL;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const LOCALE = "pl-PL";
export const PAGINATION_LIMIT = 10;
export const DEBOUNCE_DEFAULT_VALUE = 500;
